import Layout from '@/layout'
import ParentView from '@/components/ParentView'

const asyncBaseInfoRoutes =
{
  path: '/base/baseInfo',
  component: Layout,
  name: '基础信息管理',
  redirect: 'noredirect',
  funcPerms: 'system:base',
  meta: {
    title: '基础信息管理',
    icon: 'baseInfo',
    affix: false,
    noCache: true
  },
  children: [

    {
      path: 'inspectionItems',
      component: () => import('@/views/baseInfo/inspectionItems/index'),
      funcPerms: 'system:base:inspectionItems',
      name: 'InspectionItems',
      meta: {
        title: '检测项目',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'inspectionItems/add',
      component: () => import('@/views/baseInfo/inspectionItems/add'),
      funcPerms: 'system:base:inspectionItems:add',
      name: 'InspectionItemsAdd',
      hidden: true,
      meta: {
        title: '检测项目新增',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'inspectionItems/edit',
      component: () => import('@/views/baseInfo/inspectionItems/add'),
      funcPerms: 'system:base:inspectionItems:edit',
      name: 'inspectionItemsEdit',
      hidden: true,
      meta: {
        title: '检测项目编辑',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'inspectionItems/view',
      component: () => import('@/views/baseInfo/inspectionItems/detail'),
      funcPerms: 'system:base:inspectionItems:view',
      name: 'inspectionItemsView',
      hidden: true,
      meta: {
        title: '详情',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'inspectionStandards',
      component: () => import('@/views/baseInfo/inspectionStandards/index'),
      funcPerms: 'system:base:inspectionStandards',
      name: 'InspectionStandards',
      meta: {
        title: '执行标准',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'inspectionStandards/add',
      component: () => import('@/views/baseInfo/inspectionStandards/add'),
      funcPerms: 'system:base:inspectionStandards:add',
      name: 'InspectionStandardsAdd',
      hidden: true,
      meta: {
        title: '新增执行标准',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'inspectionStandards/edit',
      component: () => import('@/views/baseInfo/inspectionStandards/add'),
      funcPerms: 'system:base:inspectionStandards:edit',
      name: 'inspectionStandardsEdit',
      hidden: true,
      meta: {
        title: '编辑执行标准',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'inspectionStandards/view',
      component: () => import('@/views/baseInfo/inspectionStandards/detail'),
      funcPerms: 'system:base:inspectionStandards:view',
      name: 'inspectionStandardsDetail',
      hidden: true,
      meta: {
        title: '详情',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'InspectionBasis',
      component: () => import('@/views/baseInfo/InspectionBasis/index'),
      funcPerms: 'system:base:inspectionStandards',
      name: 'InspectionBasis',
      meta: {
        title: '检测依据',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'InspectionBasis/add',
      component: () => import('@/views/baseInfo/InspectionBasis/add'),
      funcPerms: 'system:base:inspectionStandards:add',
      name: 'InspectionBasisAdd',
      hidden: true,
      meta: {
        title: '新增检测依据',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'InspectionBasis/edit',
      component: () => import('@/views/baseInfo/InspectionBasis/add'),
      funcPerms: 'system:base:inspectionStandards:edit',
      name: 'InspectionBasisEdit',
      hidden: true,
      meta: {
        title: '检测依据编辑',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'InspectionBasis/view',
      component: () => import('@/views/baseInfo/InspectionBasis/detail'),
      funcPerms: 'system:base:inspectionStandards:view',
      name: 'InspectionBasisDetail',
      hidden: true,
      meta: {
        title: '详情',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'category',
      component: () => import('@/views/baseInfo/category/index'),
      funcPerms: 'system:base:category',
      name: '样品类别',
      meta: {
        title: '样品类别',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },

    {
      path: 'category/add',
      component: () => import('@/views/baseInfo/category/add'),
      funcPerms: 'system:base:category:related',
      hidden: true,
      // eslint-disable-next-line no-dupe-keys
      name: '关联项目标准',
      meta: {
        title: '关联项目标准',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'Department',
      component: () => import('@/views/baseInfo/Department/index'),
      funcPerms: 'system:base:department',
      name: '实验室设置',
      meta: {
        title: '实验室设置',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    // {
    //   path: 'method',
    //   component: () => import('@/views/baseInfo/method/index'),
    //   funcPerms: 'system:base:method',
    //   name: '检测方法配置',
    //   meta: {
    //     title: '检测方法配置',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    {
      path: 'detection',
      component: () => import('@/views/baseInfo/detection/index'),
      funcPerms: 'system:base:detection',
      name: 'Detection',
      meta: {
        title: '检测方法设置',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'detection/add',
      component: () => import('@/views/baseInfo/detection/add'),
      funcPerms: 'system:base:detection:add',
      name: 'DetectionAdd',
      hidden: true,
      meta: {
        title: '检测方法设置新增',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'detection/edit',
      component: () => import('@/views/baseInfo/detection/add'),
      funcPerms: 'system:base:detection:edit',
      name: 'detectionedit',
      hidden: true,
      meta: {
        title: '检测方法设置编辑',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'detection/detail',
      component: () => import('@/views/baseInfo/detection/add'),
      funcPerms: 'system:base:detection:view',
      name: 'detectiondetail',
      hidden: true,
      meta: {
        title: '检测方法设置详情',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    // {
    //   path: 'checkParamSetting/Record',
    //   component: () => import('@/views/baseInfo/checkParamSetting/Record'),
    //   funcPerms: 'system:base:checkParamSetting:setting',
    //   name: 'Record',
    //   hidden: true,
    //   meta: {
    //     title: '结果录入页面配置',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    {
      path: 'checkParamSetting/setting/:id',
      component: () => import('@/views/baseInfo/checkParamSetting/setting/index'),
      funcPerms: 'system:base:checkParamSetting:setting',
      name: 'setting',
      hidden: true,
      meta: {
        title: '结果录入页面配置',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'checkParamSetting',
      component: () => import('@/views/baseInfo/checkParamSetting/index'),
      funcPerms: 'system:base:checkParamSetting',
      name: 'checkParamSetting',
      meta: {
        title: '结果录入页面列表',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },

    // {
    //   path: '/baseInfo/detection/sampling',
    //   component: () => import('@/views/baseInfo/checkParamSetting/sampling'),
    //   funcPerms: '',
    //   name: 'detectionsampling',
    //   hidden: true,
    //   meta: {
    //     title: '采样表配置',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    {
      path: 'template/base',
      component: ParentView,
      funcPerms: 'system:base:template',
      name: '模板管理',
      meta: {
        title: '模板管理',
        icon: 'index',
        affix: false,
        noCache: true
      },
      children: [
        {
          path: '2',
          component: () => import('@/views/baseInfo/template/index'),
          funcPerms: 'system:base:template:original',
          name: '原始记录表模板',
          props: true,
          meta: {
            title: '原始记录表模板',
            icon: 'index',
            affix: false,
            noCache: true
          }
        },
        {
          path: '1',
          component: () => import('@/views/baseInfo/template/index'),
          funcPerms: 'system:base:template:entrustmentAgreement',
          name: '委托书模板',
          props: true,
          meta: {
            title: '委托书模板',
            icon: 'index',
            affix: false,
            noCache: true
          }
        },
        {
          path: '4',
          component: () => import('@/views/baseInfo/template/index'),
          funcPerms: 'system:base:template:report',
          name: '报告模板',
          props: true,
          meta: {
            title: '报告模板',
            icon: 'index',
            affix: false,
            noCache: true
          }
        },
        {
          path: '3',
          component: () => import('@/views/baseInfo/template/index'),
          funcPerms: 'system:base:template:flow',
          name: '流程卡模板',
          props: true,
          meta: {
            title: '流程卡模板',
            icon: 'index',
            affix: false,
            noCache: true
          }
        }
      ]
    },

    {
      path: 'paramSetting',
      component: ParentView,
      funcPerms: 'system:base:param',
      name: '参数模式',
      meta: {
        title: '参数模式',
        icon: 'index',
        affix: false,
        noCache: true
      },
      children: [

        {
          path: 'paramWord/2',
          component: () => import('@/views/baseInfo/paramWord/index'),
          funcPerms: 'system:base:param',
          props: true,

          name: '样品登信息参数',
          meta: {
            title: '样品信息参数',
            icon: 'index',
            affix: false,
            noCache: true
          }
        },
        {
          path: 'paramWord/3',
          component: () => import('@/views/baseInfo/paramWord/index'),
          funcPerms: 'system:base:param',
          props: true,

          name: '自定义检测参数',
          meta: {
            title: '自定义检测参数',
            icon: 'index',
            affix: false,
            noCache: true
          }
        },
        {
          path: 'paramWord/4',
          component: () => import('@/views/baseInfo/paramWord/index'),
          funcPerms: 'system:base:param',
          props: true,

          name: '结果集表头',
          meta: {
            title: '结果集表头',
            icon: 'index',
            affix: false,
            noCache: true
          }
        },

        {
          path: 'paramWord/10',
          component: () => import('@/views/baseInfo/paramWord/index'),
          funcPerms: 'system:base:param',
          props: true,

          name: '结果集表头参数',
          meta: {
            title: '结果集表头参数',
            icon: 'index',
            affix: false,
            noCache: true
          }
        },

        {
          path: 'paramWord/12',
          component: () => import('@/views/baseInfo/paramWord/index'),
          funcPerms: 'system:base:param',
          props: true,

          name: '矩阵数据',
          meta: {
            title: '矩阵数据',
            icon: 'index',
            affix: false,
            noCache: true
          }
        },

        {
          path: 'paramWord/7',
          component: () => import('@/views/baseInfo/paramWord/index'),
          funcPerms: 'system:base:param',
          props: true,

          name: '资源数据',
          meta: {
            title: '资源数据',
            icon: 'index',
            affix: false,
            noCache: true
          }
        }

      ]
    }

  ]
}

export default asyncBaseInfoRoutes
